// Defaults de la ficha de Dispositivo Médico (NT 226 / NGT 247) — espejo de backend/app/dm_validation.py
export const DM_DEFAULT_FIELDS = Object.freeze({
  es_dispositivo_medico: false,
  es_dm_priorizado: false,
  tipo_dm: null,
  categoria_implantable: null,
  dispositivo_anexo1: null,
  numero_registro_sanitario: '',
  fabricante: '',
  marca: '',
  modelo: '',
  denominacion_interna: '',
  politica_vencimiento: 'fabricante',
  criterio_fecha_sustituta: null,
  dias_fecha_sustituta: null,
  dias_alerta_vencimiento: null,
  requiere_serie: false
})

export const DM_FIELD_KEYS = Object.keys(DM_DEFAULT_FIELDS)
